import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonVariant } from '@as/cotopaxi';
import { CaretRightIcon } from '@yonderland/andes-icons';
import { Stack, ButtonLink, Icon } from '@yonderland/andes-react';
const getButtonVariant = (variant) => {
    switch (variant) {
        case ButtonVariant.OUTLINED:
        case ButtonVariant.OUTLINED_ALT:
            return 'secondary';
        default:
            return 'primary';
    }
};
export const ProductCareCTA = ({ alt, buttonVariant, label, linkPath, targetIsBlank, horizontalAlign, }) => {
    const isLinkStyle = buttonVariant === ButtonVariant.LINK || buttonVariant === ButtonVariant.LINK_SUBTLE;
    const getJustify = () => {
        if (horizontalAlign === 'start')
            return 'start';
        if (horizontalAlign === 'end')
            return 'end';
        return 'center';
    };
    return (_jsx(Stack, { justify: getJustify(), children: _jsxs(ButtonLink, { href: linkPath, target: targetIsBlank ? '_blank' : undefined, title: alt, variant: getButtonVariant(buttonVariant), size: isLinkStyle ? 'sm' : 'md', children: [label, _jsx(Icon, { source: CaretRightIcon, size: "sm" })] }) }));
};
